import { Directive, ElementRef, Renderer2, OnInit } from '@angular/core';

@Directive({
  selector: '[nimbusInvertedButton]',
  standalone: false,
})
export class NimbusMaterialInvertedButtonDirective implements OnInit {
  public constructor(
    private elementRef: ElementRef,
    private renderer: Renderer2,
  ) {}

  public ngOnInit(): void {
    this.renderer.addClass(this.elementRef.nativeElement, 'nimbus-material-button');
    this.renderer.addClass(this.elementRef.nativeElement, 'inverted');
  }
}
